
export const hlzTeamData = [
  {
    id: 1,
    image: require('../images/ComponentImg/teamMMCheng.jpg'),
    alt: 'ComponentImg/teamMMCheng.jpg',
    fbLink: 'https://www.facebook.com',
    twitterLink: 'https://www.twitter.com',
    linkedinLink: 'https://www.linkedin.com',
    employname: '陈明明',
    designation: 'CEO',
    text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Qui facilis, totam maiores.',
  },
  {
    id: 2,
    image: require('../images/ComponentImg/teamDavidAntony.jpg'),
    alt: 'ComponentImg/teamDavidAntony.jpg',
    fbLink: 'https://www.facebook.com',
    twitterLink: 'https://www.twitter.com',
    linkedinLink: 'https://www.linkedin.com',
    employname: 'David Antony',
    designation: 'Manager',
    text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Qui facilis, totam maiores.',
  },
  {
    id: 3,
    image: require('../images/ComponentImg/team3.jpg'),
    alt: 'ComponentImg/ComponentImg/team3.jpg',
    fbLink: 'https://www.facebook.com',
    twitterLink: 'https://www.twitter.com',
    linkedinLink: 'https://www.linkedin.com',
    employname: 'Nicholas Perry',
    designation: 'UX Designer',
    text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Qui facilis, totam maiores.',
  },
  {
    id: 4,
    image: require('../images/ComponentImg/teamQPan.jpg'),
    alt: 'ComponentImg/ComponentImg/teamQPan.jpg',
    fbLink: 'https://www.facebook.com',
    twitterLink: 'https://www.twitter.com',
    linkedinLink: 'https://www.linkedin.com',
    employname: '潘琴',
    designation: 'Developer',
    text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Qui facilis, totam maiores.',
  },
  {
    id: 5,
    image: require('../images/ComponentImg/team5.jpg'),
    alt: 'ComponentImg/ComponentImg/team5.jpg',
    fbLink: 'https://www.facebook.com',
    twitterLink: 'https://www.twitter.com',
    linkedinLink: 'https://www.linkedin.com',
    employname: 'Sophia Pitt',
    designation: 'Developer',
    text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Qui facilis, totam maiores.',
  },
  {
    id: 6,
    image: require('../images/ComponentImg/team6.jpg'),
    alt: 'ComponentImg/ComponentImg/team6.jpg',
    fbLink: 'https://www.facebook.com',
    twitterLink: 'https://www.twitter.com',
    linkedinLink: 'https://www.linkedin.com',
    employname: 'Taylor Lopez',
    designation: 'Developer',
    text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Qui facilis, totam maiores.',
  },
  {
    id: 7,
    image: require('../images/ComponentImg/team7.jpg'),
    alt: 'ComponentImg/ComponentImg/team7.jpg',
    fbLink: 'https://www.facebook.com',
    twitterLink: 'https://www.twitter.com',
    linkedinLink: 'https://www.linkedin.com',
    employname: 'Ryan Giggs',
    designation: 'Content Writer',
    text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Qui facilis, totam maiores.',
  }
  // {
  //   id: 8,
  //   image: require('../images/ComponentImg/team8.jpg'),
  //   fbLink: 'https://www.facebook.com',
  //   twitterLink: 'https://www.twitter.com',
  //   linkedinLink: 'https://www.linkedin.com',
  //   employname: 'David Smith',
  //   designation: 'SEO Expert',
  //   text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Qui facilis, totam maiores.'
  // }
]
